import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { ModalHeader } from 'reactstrap';
import { withStyles } from '@material-ui/core/styles';
import IntlMessages from 'util/IntlMessages';
import TextField from '@material-ui/core/TextField';
import validateInput from 'validations/login/login';
import Button from '@material-ui/core/Button';
import { userRefreshToken,checkisExpired,userSignOut } from 'actions/Auth';


function mapStateToProps({auth}) {
    return {
        authUser: auth.authUser,
        token: auth.token,
        Unauthorized: auth.Unauthorized,
        success: auth.success
      }
}


const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
class UpdateSessionToken extends Component {
    state={
        email: this.props.authUser.user_Email,
        password: '',
    }

    handleKeyPress=(e)=>{
        if (e.key === "Enter") {
          if(this.isValid()){
            this.setState({ errors: {}, isLoading: true });
            this.props.userRefreshToken({email:this.state.email, password:this.state.password}); 
                   
          }   
        }
      }
      isValid =()=>{
        const {errors, isValid} = validateInput(this.state);
       if(!isValid){
         this.setState({errors:errors})
       }
       return isValid;
       }
    render() {
        
        return (
            <Dialog 
            aria-labelledby="customized-dialog-title" 
            open={this.props.isExpired || this.props.Unauthorized === 1} 
            disableBackdropClick={true} 
            disableEscapeKeyDown={true} 
            fullWidth={true}
            maxWidth={"md"}>
                <DialogContent dividers>
                <div className="d-flex justify-content-center align-items-center w-100">
                    <div className="animated animation-duration-3">
                    <div className="app-login-main-content" style={{boxShadow: "0 0 0"}}>
                        <div className="d-flex align-items-center justify-content-center">
                            <img src={require("assets/images/Expired_Session.png")} alt="Notyfile" height={200} title="Notyfile"/>
                        </div>
                        <div className="app-login-content">
                        <div className="app-login-header mb-4">
                            <h1><IntlMessages id="Session.header" /></h1>
                            <h4><IntlMessages id="Session.body" /></h4>
                        </div>
                        <div className="app-login-form">
                        <form>
                        <fieldset>
                        <TextField
                        label={<IntlMessages id="E-mail"/>}
                        fullWidth
                        value={this.state.email}
                        disabled={true}
                        className="mt-1 my-sm-1"
                        size="small"
                        variant="outlined"
                        />
                        <TextField
                        label={<IntlMessages id="PassWord"/>}
                        fullWidth
                        onChange={(event) => this.setState({password: event.target.value,errors:[]})}
                        type="password"
                        defaultValue={this.state.password}
                        onKeyPress={this.handleKeyPress}
                        className="mt-1 my-sm-1"
                        size="small"
                        variant="outlined"
                        />
                         <div className="mb-3 d-flex align-items-center justify-content-between">
                         <Button
                         size="small"
                         onClick={() => {
                             if(this.isValid()){
                                 this.setState({ errors: {}, isLoading: true });
                                 this.props.userRefreshToken({email:this.state.email, password:this.state.password});                        
                                }                    
                            }} variant="contained" color="primary">
                                <IntlMessages id="Session.Resume"/>
                            
                            </Button>
                            <Button
                         size="small"
                         onClick={() => {
                            this.props.userSignOut()              
                            }} variant="contained" color="secondary">
                                <IntlMessages id="Log.ut"/>
                            </Button>
                         </div>
                        </fieldset>
                        </form>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </DialogContent>     
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps, {userRefreshToken,checkisExpired,userSignOut}
)(UpdateSessionToken);